/*
 * statusZuText.ts
 *
 * Created by Dr. Maximillian Dornseif 2023-11-10 in huWaWi3 33.7.0
 * Copyright (c) 2023 HUDORA GmbH
 */

export function statusToText(status: string) {
  switch (status) {
    case '400zugeteilt':
      return 'Bearbeitung durch Lager (400zugeteilt)'
    case '600last_part_shipped':
      return 'komplett versendet (600last_part_shipped)'
    default:
      return status
  }
}
